import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faAngleRight,
	faAngleDown,
	faAngleLeft,
	faAngleDoubleUp,
	faBars,
	faFileUpload,
	faEnvelope,
	faUndoAlt,
	faCircleNotch,
	faCheck,
	faPlay,
	faPause,
	faBackward,
	faFileAlt,
	faFileArchive,
	faDownload,
	faList,
	faMusic,
	faArrowDown,
	faTimes,
	faCircle,
	faArrowUp,
} from '@fortawesome/free-solid-svg-icons';
import {
	faFacebookSquare,
	faFacebookF,
	faLinkedin,
	faLinkedinIn,
	faTwitterSquare,
	faTwitter,
	faInstagram,
	faYoutubeSquare,
	faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';


// FA setup
library.add(
	faAngleRight,
	faAngleDown,
	faAngleLeft,
	faAngleDoubleUp,
	faBars,
	faFileUpload,
	faEnvelope,
	faUndoAlt,
	faCircleNotch,
	faCheck,
	faPlay,
	faPause,
	faBackward,
	faFileAlt,
	faFileArchive,
	faDownload,
	faList,
	faMusic,
	faArrowDown,
	faTimes,
	faCircle,
	faArrowUp,
);
library.add(
	faFacebookF,
	faFacebookSquare,
	faLinkedin,
	faLinkedinIn,
	faTwitterSquare,
	faTwitter,
	faInstagram,
	faYoutubeSquare,
	faYoutube,
);
Vue.component('fa-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app');
